<template>
    <div ref="map" :style="{ height: height + 'px', width: '100%' }"></div>
</template>

<script>
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Fix för att default marker ska fungera i bundlers
// eslint-disable-next-line no-underscore-dangle
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});

export default {
    name: 'OpenStreetMapLeaflet',
    props: {
        height: {
            type: Number,
            default: 400,
        },
        // Array av markörer: [{ lat: 59.3, lon: 18.0, label: "Hej" }, ...]
        markers: {
            type: Array,
            default: () => [],
        },
        // Default center om markers är tomt
        center: {
            type: Object,
            default: () => ({ lat: 58.5904, lon: 16.2249 }),
        },
        zoom: { type: Number, default: 11 },
    },
    data() {
        return {
            map: null,
            leafletMarkers: [],
        };
    },
    mounted() {
        this.map = L.map(this.$refs.map).setView([this.center.lat, this.center.lon], this.zoom);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; OpenStreetMap contributors',
        }).addTo(this.map);

        this.renderMarkers();
    },

    watch: {
        markers: {
            deep: true,
            handler() {
                this.renderMarkers();
            },
        },
    },

    methods: {
        renderMarkers() {
            // ta bort gamla
            this.leafletMarkers.forEach((m) => m.remove());
            this.leafletMarkers = [];

            if (!this.markers.length) return;

            // lägg till nya
            this.markers.forEach((m) => {
                const marker = L.marker([m.lat, m.lon]).addTo(this.map);

                if (m.label) {
                    marker.bindPopup(m.label);
                }

                this.leafletMarkers.push(marker);
            });

            // auto-zoom så alla markörer syns
            const bounds = L.latLngBounds(this.markers.map((m) => [m.lat, m.lon]));
            this.map.fitBounds(bounds, { padding: [30, 30], maxZoom: this.zoom });
        },
    },
    beforeDestroy() {
        if (this.map) {
            this.map.remove();
        }
    },
};
</script>
